// import React, { useState, useEffect } from "react";
// import sanityClient from "../../client";
import { usePosts } from '../../hooks/usePost'
import img_close from "../../assets/sidebar/close.svg";
import img_instagram from "../../assets/sidebar/instagram.svg";
import england_flag from "../../assets/navbar/icon_flag_england.svg";
import spain_flag from "../../assets/navbar/icon_flag_spain.svg";
import { NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import "./Sidenav.css";

function Sidenav({ show, setShow }) {
  const {loading, posts} = usePosts();
  const { t, i18n } = useTranslation();
  var body = document.getElementById("body");


  const hideSideNav = () => {
    body.style.overflow = "auto";
    setShow(!show);
  };
  function changeToEnglish() {
    i18n.changeLanguage("en");
  }
  function changeToSpanish() {
    i18n.changeLanguage("es");
  }
  return (
    <>
      <div className={show ? "sidebar active" : "sidebar"}>
        <nav>
          <img
            src={img_close}
            alt="img_close"
            className="img_close"
            onClick={hideSideNav}
          />
          <div className="line"></div>
          <div className="menu">
            <div className="hover_effect">
              <p className="item_menu">{t("sidenav.projects")}</p>
            </div>
            <ul className="subMenu show">
              {!loading &&
                posts.map((item, i) => {           
                    return(
                        <li key={i}>
                          <NavLink
                            to={"/post/" + item._id + '?index=' + i}
                            onClick={hideSideNav}
                          >
                            {item.title.es}
                          </NavLink>
                        </li>
                    )
                } )}
            </ul>
            <div className="hover_effect">
              <HashLink
                scroll={(el) =>
                  el.scrollIntoView({ behavior: "smooth", block: "center" })
                }
                to="/#aboutme"
                className="item_menu"
                onClick={hideSideNav}
              >
                {t("sidenav.aboutme")}
              </HashLink>
            </div>
            <div className="hover_effect">
              <HashLink
                to="/#contact"
                scroll={(el) =>
                  el.scrollIntoView({ behavior: "smooth", block: "center" })
                }
                className="item_menu"
                onClick={hideSideNav}
              >
                {t("sidenav.contact")}
              </HashLink>
            </div>
          </div>
          <div className="line"></div>
          <div className="languages_sidebar">
            <img
              src={england_flag}
              alt="english"
              className="sidenav_flag"
              onClick={() => {
                changeToEnglish();
                hideSideNav();
              }}
            />
            <img
              src={spain_flag}
              alt="spanish"
              className="sidenav_flag"
              onClick={() => {
                changeToSpanish();
                hideSideNav();
              }}
            />
          </div>
          <div className="line"></div>
          <a
            href="https://www.instagram.com/guillespers/"
            target="blank"
            className="link_ig"
          >
            <img src={img_instagram} alt="logo_instagram" />
            {t("sidenav.instagram")}
          </a>
        </nav>
      </div>
      <div
        className={show ? "sidenav__overlay visible" : "sidenav__overlay"}
        onClick={hideSideNav}
      ></div>
    </>
  );
}

export default Sidenav;
